export default __webpack_public_path__ + "static/media/edit_talent_review.97efc534.svg";